/**
 * Utilitaire pour afficher des confirmations/alertes
 * Similaire au système de toasts mais pour les confirmations
 * 
 * @example
 * import confirmAlert from '../utils/confirmAlert';
 * 
 * confirmAlert({
 *   title: 'Déconnexion',
 *   message: 'Êtes-vous sûr de vouloir vous déconnecter ?',
 *   onConfirm: () => {
 *     // Action à exécuter si confirmé
 *     logoutUser();
 *   },
 *   type: 'warning'
 * });
 */

const confirmAlert = (options) => {
  if (typeof window !== 'undefined' && window.showConfirmation) {
    window.showConfirmation({
      title: options.title || "Confirmation",
      message: options.message || "Êtes-vous sûr ?",
      onConfirm: options.onConfirm || (() => {}),
      onCancel: options.onCancel || (() => {}),
      confirmText: options.confirmText || "Confirmer",
      cancelText: options.cancelText || "Annuler",
      type: options.type || "warning" // warning, danger, info
    });
  } else {
    // Fallback vers window.confirm si le composant n'est pas encore monté
    const confirmed = window.confirm(
      `${options.title || "Confirmation"}\n\n${options.message || "Êtes-vous sûr ?"}`
    );
    if (confirmed && options.onConfirm) {
      options.onConfirm();
    } else if (!confirmed && options.onCancel) {
      options.onCancel();
    }
  }
};

export default confirmAlert;

